module.exports = __webpack_public_path__ + "static/media/school-img2.d01a93ed.png";